(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/init.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let gameResultModel;
function fetchPreviousMonth(month, year, options) {
  if (month === 0) {
    month = 11;
    year = year - 1;
  } else {
    month = month - 1;
  }
  gameResultModel.fetchMonth(month, year, options);
}
function fetchLatestDate(success) {
  const dateToday = svs.numbergames.results.parsers.datePicker.createDate(svs.numbergames.data.results.todayDateString);
  const month = dateToday.getMonth();
  const year = dateToday.getFullYear();
  gameResultModel.fetchMonth(month, year, {
    success: model => {
      if (model.getLatestDraw()) {
        if (typeof success === 'function') success(model);
      } else {
        fetchPreviousMonth(month, year, {
          success
        });
      }
    },
    error: () => fetchPreviousMonth(month, year, {
      success
    })
  });
}
function fetchLatestResult(success) {
  fetchLatestDate(model => gameResultModel.fetchResultByDraw(model.getLatestDraw(), {
    success
  }));
}
function setResultToShow(selectedDate) {
  if (selectedDate) {
    gameResultModel.set('selectedDate', svs.numbergames.results.parsers.datePicker.createDate(selectedDate));
  } else {
    fetchLatestResult(model => {
      gameResultModel.set('selectedDate', svs.numbergames.results.parsers.datePicker.createDate(model.get('regCloseTime')), {
        silent: true
      });
    });
  }
}

function getResultModel(_ref) {
  let {
    data,
    product,
    selectedDate
  } = _ref;
  if (!gameResultModel) {
    const attrs = data || {};
    gameResultModel = new svs.numbergames.results.models.GameResult(_objectSpread(_objectSpread({}, attrs), {}, {
      product,
      selectedDate
    }), {
      parse: true
    });

    if (!gameResultModel.get('availableDates').length) {
      selectedDate = undefined;
    }
    if (gameResultModel.get('results').isEmpty()) {
      setResultToShow(selectedDate);
    }
  } else {
    setResultToShow(selectedDate);
  }
  return gameResultModel;
}
svs.numbergames.results.getResultModel = getResultModel;

 })(window);